
























import RootElement from '@/components/common/RootElement.vue';
import {Vue, Component, Model, Prop} from 'vue-property-decorator';
@Component({
  components: {RootElement}
})
export default class RadioElement extends Vue {
  @Prop({default: 'span'})
  private tag!: string;

  @Prop({required: true}) private radioOptions!: any;
  @Prop() private disabled?: boolean;

  @Prop({default: false}) private verticalRadio!: boolean;
  @Prop({default: false}) private nonI18nConvert!: boolean;

  @Model('change') readonly value!: number | string;
  get modelValue() {
    return this.value;
  }
  set modelValue(val) {
    this.$emit('change', val);
  }
  private focus() {
    (this.$refs.radio as any)[0].focus();
  }
}
